import { styled } from 'styled-components';

export const Stack = styled.div`
    margin-bottom: 24px;

    @media screen and (min-width: 768px) {
        margin-bottom: 40px;
    }
`;
